import { useEffect, useRef, useState } from "react";

// This checks if the element has passed out of view by 1px. The element should therefore be set to become sticky at -1px.
// This hook is currently very specific to behavior of headers on the view page.
// It could potentially be useful as a generic hook in the future, but there are some caveats that would need to be addressed:
// - this only works for components stuck to the top of the viewport
// - we would want to evaluate whether there are any issues with SSR (e.g. if a page loaded already scrolled)
// - this should not be used to change position, as that could potentially lead to issues with circular logic / an infinite loop.
// Approach from https://davidwalsh.name/detect-sticky.
function useIsStuckVertically() {
  const [isStuck, setIsStuck] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => entry && setIsStuck(entry.boundingClientRect.y < 0),
      { threshold: [1] },
    );

    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return { isStuck, ref };
}

export default useIsStuckVertically;
